/* Bar Fridges Australia — Compare, the site-wide half.
   Authored, not generated: edit this file. Loaded on every page by
   snippets/bfau-compare.liquid, which bfau-customisations.liquid renders.

   Three jobs, and nothing else:

     1. THE PICKS. One list of product handles in localStorage under
        'bfau.cmp', shared by every page. The Frothy Finder, the theme's
        product cards, the product page and the compare page all read and
        write it through window.BFAU_CMP, so a fridge ticked anywhere is
        ticked everywhere.
     2. THE BUTTONS. A Compare tickbox added to the foot of every theme product
        card (.t4s-product) whose product is a comparable fridge, and wiring
        for the product page's button (snippets/bfau-compare-button.liquid).
     3. THE TRAY. The bar pinned to the foot of the screen once anything is
        picked, whose Compare button goes to the compare page.

   The compare page itself is the Frothy Finder engine in page mode
   (snippets/bfau-frothy-compare.liquid, generated by
   tools/frothy-finder/build-liquid.js) — the rows, the fit maths and the ▲
   marks are the finder's, not a second copy of them here.

   FRIDGES ONLY. Which products are comparable is the finder's answer, read
   from the same frothy-data.json asset the finder loads: in the finder, and
   not an accessory or camping gear. The asset is fetched only on a page that
   has product cards, a compare button or a pick to show in the tray.

   TWO ON A PHONE, THREE ABOVE 700px, the finder's rule and for its reason:
   at 390px two columns hold "750x570x865mm" on a line and three do not.
   Picking past the limit replaces the OLDEST pick and says so. */
(function(){
  'use strict';
  if (window.BFAU_CMP) return;

  var CFG = window.BFAU_CMP_CFG || {};
  var KEY = 'bfau.cmp';
  /* From the last CHANGE, not the last visit — same reasoning as the finder's
     saved search, on a longer clock because a comparison is a purchase being
     weighed over days, not a search being typed. */
  var TTL_DAYS = 30;
  var PHONE = window.matchMedia ? window.matchMedia('(max-width:700px)') : null;
  function max(){ return PHONE && PHONE.matches ? 2 : 3; }

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  /* ── The list ───────────────────────────────────────────────────────── */

  function read(){
    try {
      var r = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (r && Array.isArray(r.h) && r.exp > Date.now()){
        return r.h.filter(function(h, i, all){ return typeof h === 'string' && h && all.indexOf(h) === i; });
      }
      if (r) localStorage.removeItem(KEY);
    } catch (e) {}
    return [];
  }
  /* In memory is the truth for this page; storage is best effort. Private
     browsing or a full quota still compares, it just forgets on reload. */
  var LIST = read();
  while (LIST.length > max()) LIST.shift();

  function write(){
    try {
      if (!LIST.length) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, JSON.stringify({ h: LIST, exp: Date.now() + TTL_DAYS * 864e5 }));
    } catch (e) {}
  }
  function emit(){
    var ev;
    try { ev = new CustomEvent('bfau:cmp', { detail: { list: LIST.slice() } }); }
    catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('bfau:cmp', false, false, { list: LIST.slice() }); }
    document.dispatchEvent(ev);
  }
  function changed(){ write(); sync(); emit(); }

  /* ── The records ────────────────────────────────────────────────────── */

  /* handle -> finder record. null until loaded; the finder and the compare
     page hand over theirs with adopt() rather than making this fetch the same
     426KB a second time. */
  var RECS = null, RECS_P = null;
  function adopt(list){
    if (!Array.isArray(list)) return;
    var m = RECS || {};
    list.forEach(function(f){ if (f && f.handle) m[f.handle] = f; });
    RECS = m;
    if (!RECS_P) RECS_P = Promise.resolve(RECS);
    scanSoon(); sync();
  }
  function records(){
    if (RECS_P) return RECS_P;
    if (!CFG.data || !window.fetch) return (RECS_P = Promise.resolve(null));
    RECS_P = fetch(CFG.data, { credentials: 'omit' })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(d){ adopt(d); return RECS; })
      .catch(function(e){
        if (window.console && console.warn) console.warn('[bfau-compare] fridge data failed:', (e && e.message) || e);
        return null;
      });
    return RECS_P;
  }
  /* The finder's own comparable(): an esky beside a bar fridge is not a
     comparison, and neither is a hinge kit. */
  function comparable(f){ return !!f && !f.accessory && !f.camping; }
  /* A handle the data has never heard of is trusted, not refused: the product
     page only renders its button for a product in the finder collection, and
     one tagged in since the last rebuild is in the live feed but not the
     asset. Only a record that is KNOWN to be gear is turned away. */
  function allowed(h){ return !RECS || !RECS[h] || comparable(RECS[h]); }

  function shortTitle(f){ return String(f.title || '').replace(/\s*[-–]\s*Model\b.*$/i, ''); }
  function name(h){
    var f = RECS && RECS[h];
    if (!f) return 'your first pick';
    return (f.brand ? f.brand + ' ' : '') + (f.model || shortTitle(f));
  }

  /* ── Changing it ────────────────────────────────────────────────────── */

  function set(h, on){
    h = String(h || '');
    if (!h) return;
    var at = LIST.indexOf(h);
    if (on && at === -1){
      if (!allowed(h)){ sync(); return; }
      if (LIST.length >= max()){
        var out = LIST.shift();
        toast('Swapped out ' + name(out) + ' — compare holds ' + max() + (max() === 2 ? ' on a phone' : ''));
      }
      LIST.push(h);
    } else if (!on && at !== -1){
      LIST.splice(at, 1);
    } else {
      sync();
      return;
    }
    changed();
  }
  /* A whole list at once — the compare page opening on a shared link. The
     link wins over what was stored, and is cut to this screen's limit. */
  function setAll(list){
    var next = [];
    (list || []).forEach(function(h){ h = String(h || '').trim(); if (h && next.indexOf(h) === -1 && allowed(h)) next.push(h); });
    while (next.length > max()) next.shift();
    if (next.join(',') === LIST.join(',')) return;
    LIST = next;
    changed();
  }
  function clear(){ if (LIST.length){ LIST = []; changed(); } }

  function pageUrl(list){
    var l = list || LIST;
    return (CFG.page || '/pages/compare') + (l.length ? '?cmp=' + l.map(encodeURIComponent).join(',') : '');
  }

  /* ── The buttons ────────────────────────────────────────────────────── */

  /* One markup for every button this file owns: a real checkbox in a label,
     so it is a tickbox to a screen reader and a 44px target to a thumb. */
  function button(h, text, kind){
    return '<label class="bfau-cmp bfau-cmp--' + kind + '"><input type="checkbox" data-bfau-cmp="' + esc(h) + '"'
      + (LIST.indexOf(h) !== -1 ? ' checked' : '') + '><span>' + esc(text) + '</span></label>';
  }

  /* Every theme product card, wherever it is — collection grids, search
     results, the homepage and related-product carousels, infinite scroll —
     is a .t4s-product carrying its handle in data-product-options. One pass
     over those, once the records say which are fridges, then again whenever
     something new lands in the page. The finder draws its own cards and its
     own tickbox, so anything inside .frothy is left alone.

     The handle is read with a pattern rather than JSON.parse: the attribute is
     the theme's, written by seven card snippets, and a stray character in some
     other field of it should not cost the card its button. */
  function scan(){
    if (!RECS) return;
    var cards = document.querySelectorAll('.t4s-product[data-product-options]:not([data-bfau-cmp-seen])');
    for (var i = 0; i < cards.length; i++){
      var c = cards[i];
      c.setAttribute('data-bfau-cmp-seen', '');
      if (c.closest('.frothy')) continue;
      var m = /"handle"\s*:\s*"([^"]+)"/.exec(c.getAttribute('data-product-options') || '');
      if (!m || !comparable(RECS[m[1]])) continue;
      /* Last in the wrapper, below the spec list, so a row of stretched cards
         puts every tickbox on one line — the finder's placement exactly. */
      var host = c.querySelector('.t4s-product-wrapper') || c;
      host.insertAdjacentHTML('beforeend', button(m[1], 'Compare', 'card'));
      c.classList.toggle('bfau-picked', LIST.indexOf(m[1]) !== -1);
    }
  }
  var SCAN_Q = false;
  function scanSoon(){
    if (SCAN_Q) return;
    SCAN_Q = true;
    (window.requestAnimationFrame || setTimeout)(function(){ SCAN_Q = false; scan(); });
  }

  /* ── The tray ───────────────────────────────────────────────────────── */

  var TRAY = null, TOAST = null;
  /* Not on the compare page, which is the thing the tray links to. */
  function trayWanted(){ return !document.querySelector('.frothy[data-cpage]'); }

  function buildTray(){
    if (TRAY || !document.body) return TRAY;
    var d = document.createElement('div');
    d.innerHTML = '<div class="bfau-ctray" data-bfau-tray aria-live="polite"><div class="bfau-ctray-in">'
      + '<div class="bfau-cslots" data-bfau-slots></div>'
      + '<div class="bfau-ctxt" data-bfau-txt></div>'
      + '<a class="bfau-cgo" data-bfau-go href="' + esc(pageUrl()) + '">Compare</a>'
      + '</div></div>'
      + '<div class="bfau-ctoast" data-bfau-toast role="status"></div>';
    TRAY = d.firstChild;
    TOAST = d.lastChild;
    document.body.appendChild(TRAY);
    document.body.appendChild(TOAST);
    TRAY.addEventListener('click', function(e){
      var x = e.target.closest && e.target.closest('[data-bfau-unpick]');
      if (x){ set(x.getAttribute('data-bfau-unpick'), false); return; }
      if (e.target.closest && e.target.closest('[data-bfau-clear]')){ clear(); return; }
      var go = e.target.closest && e.target.closest('[data-bfau-go]');
      if (go && LIST.length < 2) e.preventDefault();
    });
    return TRAY;
  }

  function renderTray(){
    var n = LIST.length, root = document.documentElement;
    if (!n || !trayWanted()){
      if (TRAY) TRAY.classList.remove('is-on');
      root.classList.remove('bfau-cmp-on');
      return;
    }
    if (!buildTray()) return;
    var mx = max(), slots = '';
    for (var s = 0; s < mx; s++){
      var h = LIST[s], f = h && RECS ? RECS[h] : null;
      slots += h
        ? '<div class="bfau-cslot is-full">' + (f && f.img ? '<img src="' + esc(f.img) + '" alt="">' : '')
          + '<button class="bfau-cslot-x" type="button" data-bfau-unpick="' + esc(h) + '" aria-label="Remove '
          + esc(name(h) === 'your first pick' ? 'this fridge' : name(h)) + ' from compare">&times;</button></div>'
        : '<div class="bfau-cslot" aria-hidden="true"></div>';
    }
    TRAY.querySelector('[data-bfau-slots]').innerHTML = slots;
    TRAY.querySelector('[data-bfau-txt]').innerHTML = '<b>' + n + ' of ' + mx + ' picked</b>'
      + (n < 2 ? 'Pick one more to compare' : n < mx ? 'Ready — or add one more' : 'Ready to compare')
      + ' <button class="bfau-cclear" type="button" data-bfau-clear>Clear</button>';
    var go = TRAY.querySelector('[data-bfau-go]');
    go.href = pageUrl();
    go.textContent = n < 2 ? 'Compare' : 'Compare ' + n + ' →';
    go.setAttribute('aria-disabled', n < 2 ? 'true' : 'false');
    go.classList.toggle('is-off', n < 2);
    TRAY.classList.add('is-on');
    root.classList.add('bfau-cmp-on');
    toolbarGap();
  }

  var TOAST_T = 0;
  function toast(msg){
    buildTray();
    if (!TOAST) return;
    TOAST.textContent = msg;
    TOAST.classList.add('is-on');
    clearTimeout(TOAST_T);
    TOAST_T = setTimeout(function(){ TOAST.classList.remove('is-on'); }, 2800);
  }

  /* The theme's mobile toolbar (sections/toolbar_mobile.liquid: All Products /
     Cart, fixed to the bottom up to 1024px) is measured, not assumed. The tray
     sits on top of it so the cart stays one tap away, and where it is not
     drawn the tray drops to the screen edge and takes the safe-area inset.
     --bfau-tb and --bfau-tray-h also lift the Coax "Text us" bubble clear of
     the open tray - see bfau-compare.css. */
  function toolbarGap(){
    var root = document.documentElement, tb = document.querySelector('.t4s-toolbar'), h = 0;
    if (tb){
      var cs = getComputedStyle(tb);
      if (cs.display !== 'none' && cs.visibility !== 'hidden') h = Math.round(tb.getBoundingClientRect().height);
    }
    root.style.setProperty('--bfau-tb', h + 'px');
    root.style.setProperty('--bfau-tb-safe', h ? '0px' : 'env(safe-area-inset-bottom, 0px)');
    if (TRAY) root.style.setProperty('--bfau-tray-h', TRAY.offsetHeight + 'px');
  }

  /* ── Bringing every picture of the list into line ───────────────────── */

  /* The tickboxes this file owns, the ring on their cards, the product page
     button's words, and the tray. Cheap enough to run whole on every change,
     and running it whole is what stops them disagreeing. The finder and the
     compare page listen for 'bfau:cmp' and sync their own. */
  function sync(){
    var boxes = document.querySelectorAll('input[data-bfau-cmp]');
    for (var i = 0; i < boxes.length; i++){
      var b = boxes[i], h = b.getAttribute('data-bfau-cmp'), on = LIST.indexOf(h) !== -1;
      b.checked = on;
      var lab = b.closest('.bfau-cmp');
      if (lab){
        /* Gear that got a product page button by being in the collection. */
        if (RECS && RECS[h] && !comparable(RECS[h])) lab.hidden = true;
        var t = lab.querySelector('[data-bfau-cmp-text]');
        if (t) t.textContent = on ? t.getAttribute('data-on') : t.getAttribute('data-off');
        var more = lab.parentNode && lab.parentNode.querySelector('[data-bfau-cmp-view]');
        if (more){ more.hidden = !on || LIST.length < 2; more.href = pageUrl(); }
      }
      var card = b.closest('.t4s-product');
      if (card) card.classList.toggle('bfau-picked', on);
    }
    renderTray();
  }

  /* ── Wiring ─────────────────────────────────────────────────────────── */

  document.addEventListener('change', function(e){
    var b = e.target;
    if (b && b.matches && b.matches('input[data-bfau-cmp]')) set(b.getAttribute('data-bfau-cmp'), b.checked);
  });

  /* Another tab changed the list. */
  window.addEventListener('storage', function(e){
    if (e.key !== KEY) return;
    LIST = read();
    while (LIST.length > max()) LIST.shift();
    sync(); emit();
  });

  /* Turning a tablet or dragging a window across 700px changes the limit.
     The oldest picks go, same rule as a tick past the limit. */
  function onBreak(){
    var cut = false;
    while (LIST.length > max()){ LIST.shift(); cut = true; }
    if (cut){ toast('Compare holds ' + max() + ' at this size — kept your latest picks'); changed(); }
    else sync();
  }
  if (PHONE){
    if (PHONE.addEventListener) PHONE.addEventListener('change', onBreak);
    else if (PHONE.addListener) PHONE.addListener(onBreak);
  }
  window.addEventListener('resize', function(){ if (LIST.length) toolbarGap(); });

  /* Back from a product page restores this page from the back/forward cache
     with the tickboxes as they were when it was left — which may not be the
     list any more. */
  window.addEventListener('pageshow', function(e){
    if (!e.persisted) return;
    LIST = read();
    while (LIST.length > max()) LIST.shift();
    sync(); emit();
  });

  function start(){
    var needData = LIST.length
      || document.querySelector('input[data-bfau-cmp]')
      || document.querySelector('.t4s-product[data-product-options]');
    /* The finder and the compare page load the same asset and adopt() it;
       fetching it here as well would race them for 426KB. */
    if (needData && !document.querySelector('.frothy')) records().then(function(){ scan(); sync(); });
    sync();

    if (window.MutationObserver){
      new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++){
          if (muts[i].addedNodes.length){
            /* A carousel or infinite scroll that brought the first cards. */
            if (!RECS_P && !document.querySelector('.frothy')
              && document.querySelector('.t4s-product[data-product-options]')) records().then(scanSoon);
            scanSoon();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.BFAU_CMP = {
    list: function(){ return LIST.slice(); },
    has: function(h){ return LIST.indexOf(h) !== -1; },
    set: set,
    setAll: setAll,
    clear: clear,
    max: max,
    url: pageUrl,
    adopt: adopt,
    name: name,
    toast: toast,
    remeasure: toolbarGap
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
